module.exports = __webpack_public_path__ + "static/media/Maf_SEGOB.055a25bd.jpg";